import { useQuery } from '@tanstack/react-query';

export function useFoldersQuery({ params, queryOptions }) {
  return useQuery({
    queryKey: ['folders', params],
    queryFn: async () => {
      const response = await axios.get('/folders', { params });

      return response.data;
    },
    ...queryOptions,
  });
}

export function useFolderQuery({ id, queryOptions }) {
  return useQuery({
    queryKey: ['folders', id],
    queryFn: async () => {
      const response = await axios.get(`/folders/${id}`);

      return response.data;
    },
    ...queryOptions,
  });
}
